<script>
  //import { auth, db } from "../etc/firebase.js"
  import {
    userStore,
    guaRecordStore,
    userGuaCount,
    selectedLanguage,
  } from "../etc/store.js"
  import PrivatePage from "./PrivatePage.svelte"
  import Record from "./Record.svelte"
  import "materialize-css"

  import {
    decryptText,
    onlyUnique,
    btn_style_lime_d2,
    btn_style_light_blue_a3,
    btn_style_green_l2,
    btn_style_green_d2,
    btn_style_bluegrey_l2,
    btn_style_indigo_l1,
    btn_style_orange_d2,
  } from "../etc/helpers.js"

  document.addEventListener("DOMContentLoaded", function () {
    var items = document.querySelectorAll(".collapsible")
    M.Collapsible.init(items)
  })

  let firebaseUid = ""
  let userName = ""
  let showRecord = false
  let guaRecordsFromDB = []
  let myRecords = []
  let myRecordsCopy = []
  let isLogin = false
  let guaCount = 0
  let eachObj = {}
  let cats = []
  let tags = []
  let catsLength = 0
  let tagsLength = 0
  let newRecordsLength = 0

  // Listen for auth status change
  $: if ($userStore.isLogin == true) {
    isLogin = true

    firebaseUid = $userStore.userInfo.firebaseUid
    userName = $userStore.userInfo.userName

    // console.log(
    //   "@ Records.in $: if $userStore.isLogin, typeof $guaRecordStore is ",
    //   typeof $guaRecordStore
    // )
    if ($guaRecordStore.length != 0) {
      // console.log(
      //   "@ Records.in $: if $userStore.isLogin, JSON.parse($guaRecordStore) = ",
      //   JSON.parse($guaRecordStore)
      // )
      guaRecordsFromDB = JSON.parse($guaRecordStore)
      myRecords = [...guaRecordsFromDB]
      // console.log(
      //   "@ Records.in $: if $userStore.isLogin, now guaRecordsFromDB is = ",
      //   guaRecordsFromDB
      // )
    } else {
      // console.log(
      //   "@ Records.in $: if $userStore.isLogin. $guaRecordStore is empty"
      // )
    }

    cats = getCats(guaRecordsFromDB)
    // console.log(
    //   "@ Records.in $: if $userStore.isLogin. - got initial cats = ",
    //   cats
    // )

    tags = getTags(guaRecordsFromDB)
    // console.log(
    //   "@ Records.in $: if $userStore.isLogin. - got initial tags = ",
    //   tags
    // )

    //resetToShowAllCatsTags()
    selectedCats = []
    selectedTags = []
    showRecord = true

    cats.forEach((cat) => {
      showCats[cat] = true
    })
    tags.forEach((tag) => {
      showTags[tag] = true
    })

    //newRecordsLength = $userGuaCount
  } else {
    isLogin = false
    showRecord = false
    //newRecordsLength = $userGuaCount
  }

  $: if (newRecordsLength != null) {
    if (selectedTags.length == 0 && selectedCats.length == 0) {
      newRecordsLength = $userGuaCount
    }
    //  console.log("@ Records.newRecordsLength =  " + newRecordsLength)
  }

  $: if (cats.length != catsLength) {
    //console.log("@ Records - cats changing", myRecords)
    catsLength = cats.length
  }

  $: if (tags.length != tagsLength) {
    // console.log("@ Records - tags changing", myRecords)
    tagsLength = tags.length
  }

  function getCats(rc) {
    let catArray = []

    rc.forEach((doc) => {
      // if (doc.content.category != "") catArray.push(doc.content.category)
      if (doc.category != "") catArray.push(doc.category)
    })

    return catArray.filter(onlyUnique)
  }

  function getTags(rc) {
    let tagArray = []
    let flattenArray = []
    let cleanedArray = []

    rc.forEach((doc) => {
      // tagArray.push(doc.tag)
      tagArray.push(doc.tag)
    })

    //  console.log("@ Record - getTags tagArray.length = " + tagArray.length)

    flattenArray = [].concat.apply([], tagArray)
    // console.log(
    //   "@ Record - getTags flattenArray.length = " + flattenArray.length
    // )

    flattenArray.forEach((tag) => {
      if (tag != "") cleanedArray.push(tag)
    })
    // console.log("@ Records.getTags: tagArray =", flattenArray)

    return cleanedArray.filter(onlyUnique)
  }

  // reset to show all Cats Tags
  let selectedCats = []
  let selectedTags = []
  let showCats = {}
  let showTags = {}
  function resetToShowAllCatsTags() {
    // console.log("@ Records.resetToShowAllCatsTags")

    selectedCats = []
    selectedTags = []

    cats.forEach((cat) => {
      showCats[cat] = true
    })
    tags.forEach((tag) => {
      showTags[tag] = true
    })
    myRecords.forEach((doc) => {
      doc.show = true
    })
    myRecords = [...myRecordsCopy]
    newRecordsLength = $userGuaCount
  }

  // filter function for cats and tags
  function getFilterSelections(cat, tag) {
    // console.log(
    //   "@ Records.getFilterSelections with cat : " + cat + ", tag : " + tag
    // )
    myRecordsCopy = [...guaRecordsFromDB]
    //myRecordsCopy = [...myRecords]
    myRecords = null
    newRecordsLength = 0

    // *** Handle cats ***
    if (cat != "") {
      if (showCats[cat] == true) {
        selectedCats.push(cat)
        showCats[cat] = false
      } else if (showCats[cat] == false) {
        let index = selectedCats.indexOf(cat)
        if (index > -1) {
          selectedCats.splice(index, 1)
        }
        showCats[cat] = true
      } else {
        selectedCats.push(cat)
        showCats[cat] = false
      }
      // console.log("@ Records.getFilterSelections: Got cat ", cat)
      // console.log(
      //   "@ Records.getFilterSelections: selectedCats = ",
      //   selectedCats
      // )
      // console.log(
      //   "@ Records.getFilterSelections: showCats[cat] after clicked = ",
      //   showCats[cat]
      // )

      myRecordsCopy.forEach((doc) => {
        if (selectedCats.length == 0) {
          doc.show = true
        } else if (selectedCats.includes(doc.category)) {
          doc.show = true
        } else {
          doc.show = false
        }
        // console.log(
        //   "@ Records.getFilterSelections: +++ myRecordsCopy update: question, category, show: " +
        //     doc.question +
        //     ", " +
        //     doc.category +
        //     ", " +
        //     doc.show
        // )
      })
    }

    // *** processing tags here ***
    if (tag != "") {
      if (selectedTags.includes(tag)) {
        // console.log("***** need to remove tag ", tag)
        selectedTags = selectedTags.filter((item) => item !== tag)
        // console.log("***** selectedTags are ", selectedTags)

        showTags[tag] = true
      } else if (showTags[tag] == true) {
        selectedTags.push(tag)
        showTags[tag] = false
      } else if (showTags[tag] == false) {
        let index = selectedTags.indexOf(tag)
        if (index > -1) {
          selectedTags.splice(index, 1)
        }
        showTags[tag] = true
      } else {
        selectedTags.push(tag)
        showTags[tag] = false
      }
      // console.log("***** Got tag ", tag)
      // console.log("***** selectedTags = ", selectedTags)
      // console.log("***** showTags[tag] after clicked = ", showTags[tag])

      // myRecordsCopy.forEach((item) => {
      for (let i = 0; i < myRecordsCopy.length; i++) {
        if (selectedTags.length == 0) {
          // selectedTags is now nothing. show all
          myRecordsCopy[i].show = true
        } else {
          if (myRecordsCopy[i].tag.includes(tag)) {
            // Adding to show the selected tag
            // console.log("##### have tags", tags)
            //console.log("##### got myRecordsCopy[i].tag", myRecordsCopy[i].tag)
            // console.log(
            //   "##### got flatten myRecordsCopy[i].tag",
            //   [].concat.apply([], myRecordsCopy[i].tag)
            // )

            myRecordsCopy[i].tag.forEach((tag) => {
              //              if (tags.includes(tag)) {
              if (selectedTags.includes(tag)) {
                myRecordsCopy[i].show = true
              } else {
                myRecordsCopy[i].show = false
              }
            })
          } else {
            // still need to respect previously selected tags and show the myRecordsCopy[i]
            myRecordsCopy[i].show = false
            myRecordsCopy[i].recorder = "Caca"
            //myRecordsCopy[i].show = "caca"
            // console.log("$$$$ myRecordsCopy[i].show", myRecordsCopy[i].show)
            // console.log(
            //   "$$$$ myRecordsCopy[i]['recorder']",
            //   myRecordsCopy[i]["recorder"]
            // )
            // console.log("$$$$ myRecordsCopy[i]", myRecordsCopy[i])
            myRecordsCopy[i].tag.forEach((tag) => {
              if (selectedTags.includes(tag)) {
                myRecordsCopy[i].show = true
              }
            })
          }

          // console.log(
          //   "+++ myRecordsCopy update: question, tag, show: " +
          //     myRecordsCopy[i].question +
          //     ", " +
          //     myRecordsCopy[i].tag +
          //     ", " +
          //     myRecordsCopy[i].show
          // )
          // console.log(
          //   "@ Records.in LOOP: after selected tag, myRecordsCopy[i] is ",
          //   myRecordsCopy[i]
          // )
        }
      }
      // console.log(
      //   "@ Records.getFilterSelections: after selected tag, myRecordsCopy is ",
      //   myRecordsCopy
      // )
    }

    // console.log(
    //   "@ Records.getFilterSelections: before ending the function call, myRecordCopy is ",
    //   myRecordsCopy
    // )
    // console.log(
    //   "@ Records.getFilterSelections: before ending the function call, myRecord is ",
    //   myRecords
    // )
    myRecords = [...myRecordsCopy]
    // console.log(
    //   "@ Records.getFilterSelections: AFTER selectedCatsANDTags, myRecords is ",
    //   myRecords
    // )
    myRecords.forEach((doc) => {
      if (doc.show == true) {
        newRecordsLength++
      }
    })
    // console.log("@ Records.newRecordsLength FINALLY =  " + newRecordsLength)
  }

  function prepExplanationHTML(explanationObj) {
    let explanationHTML = ""

    if (explanationObj == undefined) {
      explanationHTML = "<br/><hr/><br/>"
    } else {
      explanationHTML =
        "<br/><hr/>更新日期： " +
        explanationObj.dt +
        "<br/>解卦內容：" +
        decryptText(explanationObj.content) +
        "<br/><hr/>"
    }
    return explanationHTML
  }

  function prepCommentHTML(commentObj) {
    let commentHTML = ""
    if (commentObj == undefined) {
      commentHTML = "<br/><hr/><br/>"
    } else {
      for (var i = 0; i < commentObj.length; i++) {
        commentHTML =
          "<hr/>筆記日期： " +
          commentObj[i].dt +
          "<br/>筆記內容： " +
          decryptText(commentObj[i].content) +
          commentHTML
      }
    }

    return commentHTML
  }

  function handlePrintHTML(selectedRecords) {
    //console.log("@ Records: Read to View/Download PDF")
    //const doc = new jsPDF()

    let dt = new Date(Date.now())
    let recordText = "<h1>起卦紀錄</h1>" + "<h3>下載日期: " + dt + "</h3>"
    let gua_count = 1
    selectedRecords.forEach((doc) => {
      if (doc.show == true) {
        recordText = recordText + "<h3>" + gua_count + " : </h3>"
        recordText =
          recordText + "登錄日期： " + new Date(doc.recordDT) + "<br/>"
        recordText = recordText + "登錄人： " + doc.recorder + "<br/>"
        recordText =
          recordText + "起卦日期： " + new Date(doc.qiGuaDT) + "<br/>"
        recordText = recordText + "起卦人： " + doc.qiGuaPerson + "<br/>"
        recordText = recordText + "卦源： " + doc.guaType + "<br/>"
        recordText = recordText + "類別： " + doc.category + "<br/>"
        recordText = recordText + "標記： " + doc.tag + "<br/>"
        recordText =
          recordText + "問題： " + decryptText(doc.question) + "<br/>"
        recordText = recordText + "卦數： " + doc.guaNumbers + "<br/>"
        recordText =
          recordText +
          "解卦： " +
          prepExplanationHTML(doc.explanation) +
          "<br/>"
        // recordText +
        // "解卦： <hr/>日期： " +
        // doc.explanation.dt +
        // ",<br/>內容：" +
        // decryptText(doc.explanation.content) +
        // "<br/><hr/>"
        recordText =
          recordText +
          "筆記紀錄： " +
          prepCommentHTML(doc.comment) +
          "<br/></br>"

        gua_count++
      }
    })

    let tab = window.open("about:blank", "_blank")
    tab.document.write(recordText) // where 'html' is a variable containing your HTML
    tab.document.close() // to finish loading the page
  }

  function handleMessage(event) {
    //alert(event.detail.text)
    location.reload()
  }
</script>

{#if $selectedLanguage == "TW"}
  <main>
    {#if isLogin}
      <h4>卦例</h4>
      <h6>我共有【{$userGuaCount}】筆起卦紀錄</h6>
      <hr />
      <div class="record-dashboard">
        <div class="guas-filter" id="guas-filter">
          <div class="cat-filter">
            <h6>搜尋類別</h6>
            <div
              class={btn_style_green_d2 + " cat"}
              on:click={resetToShowAllCatsTags}
            >
              還原
            </div>
            {#each cats as cat}
              {#if showCats[cat] == null || showCats[cat] == true}
                <div
                  class={btn_style_indigo_l1 + " cat"}
                  on:click={() => getFilterSelections(cat, "")}
                >
                  {cat}
                </div>
              {:else}
                <div
                  class={btn_style_bluegrey_l2 + " cat"}
                  on:click={() => getFilterSelections(cat, "")}
                >
                  {cat}
                </div>
              {/if}
            {/each}
          </div>
          <div class="tag-filter">
            <h6>搜尋標記</h6>
            <div
              class={btn_style_green_d2 + " tag"}
              on:click={resetToShowAllCatsTags}
            >
              還原
            </div>
            {#each tags as tag}
              {#if showTags[tag] == null || showTags[tag] == true}
                <div
                  class={btn_style_light_blue_a3 + " tag"}
                  on:click={() => getFilterSelections("", tag)}
                >
                  {tag}
                </div>
              {:else}
                <div
                  class={btn_style_bluegrey_l2 + " tag"}
                  on:click={() => getFilterSelections("", tag)}
                >
                  {tag}
                </div>
              {/if}
            {/each}
          </div>
        </div>
        <div class="show-records">
          <h5 class="record-head">
            <span class="record-head-text"
              >目前展現 {newRecordsLength} / {$userGuaCount} 筆起卦紀錄</span
            >
            <button
              class={btn_style_orange_d2 + " right btn-download"}
              on:click={() => handlePrintHTML(myRecords)}>列印卦例</button
            >
          </h5>

          <ul
            class="collapsible z-depth-0 notes"
            style="border: none; display:{showRecord ? ' block' : ' none'}"
          >
            {#each myRecords as record}
              {#if record.show == true}
                <Record id={record.id} {record} on:message={handleMessage} />
                <hr />
              {/if}
              <!-- {JSON.stringify(record.data())} <br /> -->
            {/each}
          </ul>
        </div>
      </div>
    {:else}
      <PrivatePage />
    {/if}
  </main>
{:else}
  <main>
    {#if isLogin}
      <h4>卦例</h4>
      <h6>我共有【{$userGuaCount}】笔起卦纪录</h6>
      <hr />
      <div class="record-dashboard">
        <div class="guas-filter" id="guas-filter">
          <div class="cat-filter">
            <h6>搜寻类别</h6>
            <div
              class={btn_style_green_d2 + " cat"}
              on:click={resetToShowAllCatsTags}
            >
              还原
            </div>
            {#each cats as cat}
              {#if showCats[cat] == null || showCats[cat] == true}
                <div
                  class={btn_style_indigo_l1 + " cat"}
                  on:click={() => getFilterSelections(cat, "")}
                >
                  {cat}
                </div>
              {:else}
                <div
                  class={btn_style_bluegrey_l2 + " cat"}
                  on:click={() => getFilterSelections(cat, "")}
                >
                  {cat}
                </div>
              {/if}
            {/each}
          </div>
          <div class="tag-filter">
            <h6>搜寻标记</h6>
            <div
              class={btn_style_green_d2 + " tag"}
              on:click={resetToShowAllCatsTags}
            >
              还原
            </div>
            {#each tags as tag}
              {#if showTags[tag] == null || showTags[tag] == true}
                <div
                  class={btn_style_light_blue_a3 + " tag"}
                  on:click={() => getFilterSelections("", tag)}
                >
                  {tag}
                </div>
              {:else}
                <div
                  class={btn_style_bluegrey_l2 + " tag"}
                  on:click={() => getFilterSelections("", tag)}
                >
                  {tag}
                </div>
              {/if}
            {/each}
          </div>
        </div>
        <div class="show-records">
          <h5 class="record-head">
            <span class="record-head-text"
              >目前展现 {newRecordsLength} / {$userGuaCount} 笔起卦纪录</span
            >
            <button
              class={btn_style_orange_d2 + " right btn-download"}
              on:click={() => handlePrintHTML(myRecords)}>列印卦例</button
            >
          </h5>

          <ul
            class="collapsible z-depth-0 notes"
            style="border: none; display:{showRecord ? ' block' : ' none'}"
          >
            {#each myRecords as record}
              {#if record.show == true}
                <Record id={record.id} {record} on:message={handleMessage} />
                <hr />
              {/if}
              <!-- {JSON.stringify(record.data())} <br /> -->
            {/each}
          </ul>
        </div>
      </div>
    {:else}
      <PrivatePage />
    {/if}
  </main>
{/if}

<style>
  .record-dashboard {
    display: grid;
    /* grid-template-columns: 1fr 3fr; */
  }
  .guas-filter {
    background-color: rgba(208, 222, 247, 0.3);
    border: royalblue solid 2px;
    border-radius: 10px;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .show-records {
    height: 400px;
    padding-left: 10px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
  .cat-filter {
    padding-left: 15px;
    padding-top: 5px;
  }
  .cat {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .tag-filter {
    padding-left: 15px;
    padding-top: 5px;
    padding-bottom: 20px;
  }
  .tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .record-head {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 0;
    /* height: 40px; */
  }
  .record-head-text {
    margin-top: 10px;
  }
  .btn-download {
    margin-top: 10px;
    vertical-align: middle;
  }
</style>
